<style scoped>
    .textl{
        text-align: left;
    }
    .iframe-sty {
        width: 100%;
        border: none;
        height: 600px;
        
    }
    .flow{
        background: #fff;
        padding-left: 20px;
        margin-top: 4px;
    }
  
    .pdt100{
        padding-bottom: 100px !important;
    }
    .header{
        background: #fff;
        margin: 4px 0;
        font-size: 16px;
        text-align: center;
        line-height:40px;
        height:40px;
        display: flex;
        align-items: center;
        padding: 0 16px;
       
    }
    .header .back{
        background: #FFFFFF;
        border: 1px solid rgba(217,217,217,1);
        border-radius: 2px;  
        width: 60px;
        height: 28px;  
        line-height: 28px;
        font-size: 12px;
        cursor: pointer;
    }
    .import-title{
        text-align: left;
        background: #fff;
        padding: 10px 16px;
        font-size: 16px;
    }
    .import-title.second{
        margin-top: 4px;
    }
    .header .title{
      text-align: center;
      flex:1;
    }
    .customer-information{
        background: #fff;
        padding-bottom: 0px;
        font-size: 14px;
    }
    .customer-information .cols{
        background: #fff;
        display: flex;
        padding:8px 16px;
        padding-left:20px;
    }
    .customer-information .col-itms{
        display: flex;
        /* align-items: center; */
        margin-left: 20px;
        margin-bottom:10px;
    }
    .customer-information .col-itms .title{
        width: 160px;
        text-align: right;
        color:#666;
        /* margin-right: 16px; */
    }
    .customer-information .col-itms.second{
        margin-left: 100px;
    }
    .customer-information .col-itms .title span{
        color: red;
        display: none;
    }
    .import-new-wrap{
        padding-bottom: 15px;
    }
    .import-new-wrap .import-step-tip{
        text-align: left;
        padding-left: 170px;

    }
    .import-new-wrap .col-itms{
        align-items: baseline;
    }
    .operte-btns{
        background: #fff;
        margin-top: 4px;
        display: flex;
        justify-content: center;
        padding:25px 0;
        
    }
    .operte-btns .btn{
        padding: 5px 18px;
        border: 1px solid rgba(217,217,217,1);
        border-radius: 2px;
        cursor: pointer;
    
    }
    .operte-btns .btn.save{
        margin: 0 10px;
        border: 1px solid rgba(79,161,164,1);
        color: rgba(79,161,164,1);
        cursor: pointer;
    }
    .submit{
        border: 1px solid rgba(79,161,164,1);
        background: rgba(79,161,164,1);
        color:#fff;
        cursor: pointer;
    }
    .detail-btn{
        font-size: 14px;
        color: #4FA1A4;
        margin-left: 30px;
        cursor: pointer;
    }
    .file{
        display: flex;
        margin-bottom: 14px;
        text-align: left;
        align-items: center;
    }
    .file img{
        width:32px;
        height: 32px;
        margin-right: 10px;
    }
</style>

<template>
    <div  class="project-edit"  v-loading.fullscreen.lock="fullscreenLoading">
        <div class="header">
            <div class="back"  @click="$router.go(-1)">返回</div>
            <div class="title">项目立项详情</div>
        </div>
        <div class="import-title second">申请信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>客户名称：</div>
                     <div class="label textl">{{ form.tenantName }}</div>
                </div>
                <div class="col-itms">
                    <span style="margin:0 30px 0 20px;color:#E5E5E5;">|</span>
                    <div>立项人：</div>
                    <div class="label  textl">{{ form.createProjectStaffName }}</div>
                    <span style="margin:0 20px 0 30px;color:#E5E5E5;">|</span>
                </div>
                <div class="col-itms">
                    <div>立项时间：</div>
                    <div class="label  textl">{{ form.createProjectDate }}</div>
                </div>
            </div>
            <div class="cols" v-if="createProjectFileList.length&&gradeSurveyFileList.length">
                <div class="col-itms">
                    <div class="title"><span>*</span>合同附件：</div>
                    <div class="label">
                        <div class="file">
                            <img v-if="createProjectFileList&&createProjectFileList[0].name.indexOf('.doc')>-1||createProjectFileList[0].name.indexOf('.docx')>-1" :src="require('../../assets/images/word_icon.png')"  alt="" srcset=""/>
                            <img v-else  :src="require('../../assets/images/excel_icon.png')"/>
                            <span>{{createProjectFileList&&createProjectFileList[0].name}}</span>
                            <span @click="seeDetail(createProjectFileList[0].path)" class="detail-btn">查看详情</span>
                        </div>
                        <div class="file">
                            <img v-if="gradeSurveyFileList&&gradeSurveyFileList[0].name.indexOf('.doc')>-1||gradeSurveyFileList[0].name.indexOf('.docx')>-1" :src="require('../../assets/images/word_icon.png')"  alt="" srcset=""/>
                            <img v-else  :src="require('../../assets/images/excel_icon.png')"/>
                            <span>{{gradeSurveyFileList&&gradeSurveyFileList[0].name}}</span>
                            <span @click="seeDetail(gradeSurveyFileList[0].path)" class="detail-btn">查看详情</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="import-title second">客户基础资料</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>立项时间：</div>
                     <div class="label w300 textl">{{ form.createProjectDate||'-' }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>立项人：</div>
                    <div class="label w300 textl">{{ form.createProjectStaffName }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>客户名称：</div>
                     <div class="label w300 textl">{{ form.tenantName||'-' }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>公司简称：</div>
                    <div class="label w300 textl">{{ form.abbreviation ||'-'}}</div>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司类型：</div>
                    <div class="label w300 textl">{{ getName(form.platformEnterpriseType,'平台企业类型') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>是否上市：</div>
                    <div class="label w300 textl">{{ form.isIpo=='Y'?'是':'否' }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>有三方仓储：</div>
                    <div class="label w300 textl">{{ form.hasThirdPartyStorage=='Y'?'是':'否' }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>配送能力：</div>
                    <div class="label w300 textl">{{ form.hasDistributeCapacity=='Y'?'是':'否' }}</div>
                </div>
        
            </div>
            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>公司成立时间：</div>
                    <div class="label w300 textl">{{ form.registerDate||'-'}}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>注册资本(元)：</div>
                    <div class="label w300 textl">{{ form.registerCapitalAmount| numDigit }}</div>
                </div>
            </div>
            <div class="cols">
             
             <div class="col-itms ">
                 <div class="title"><span>*</span>公司组织形式：</div>
                 <div class="label w300 textl">{{ getName(form.companyType,'企业性质字典') }}</div>
             </div>
             <div class="col-itms second">
                 <div class="title"><span>*</span>行业地位：</div>
                 <div class="label w300 textl">{{getName(form.industryPosition,'行业地位') }}</div>
             </div>
            </div>
            <div class="cols">
             
             <div class="col-itms ">
                 <div class="title"><span>*</span>经营规模：</div>
                 <div class="label w300 textl">{{ getName(form.businessScale,'经营规模') }}</div>
             </div>
             <div class="col-itms second">
                 <div class="title"><span>*</span>经营范围：</div>
                 <div class="label w300 textl">{{getName(form.businessScopeList,'经营范围') }}</div>
             </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>主营品种类型：</div>
                    <div class="label w300 textl">{{  getName(form.mainProductCategoryList,'推广品类') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>主要下游客户：</div>
                    <div class="label w300 textl">{{ getName(form.downstreamCustomerList,'平台企业类型') }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>主营业务类型：</div>
                    <div class="label w300 textl">{{  getName(form.businessTypeList,'主营业务类型') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>营销费用年支出额度：</div>
                    <div class="label w300 textl">{{ getName(form.marketingExpensePayLimit,'营销费用年支出额度') }}</div>
                </div>
            </div>
            
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>公司营销费用支出对象：</div>
                    <div class="label w300 textl">{{  getName(form.marketingExpensePayObject,'公司营销费用支出对象') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>开票类型：</div>
                    <div class="label w300 textl">{{ getName(form.invoiceType,'发票选项') }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>业务员类型：</div>
                    <div class="label w300 textl">{{  getName(form.staffTypeList,'业务员类型') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>业务人员日常拜访对象：</div>
                    <div class="label w300 textl">{{  getName(form.staffVisitObjectList,'客户类型') }}</div>
                </div>
            </div>
            <!-- 第13行  -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>是否有信息部：</div>
                    <div class="label w300 textl">{{ form.hasItDept=='Y'?'是':'否' }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>信息能力：</div>
                    <div class="label w300 textl">{{  getName(form.itAbility,'高中低') }}</div>
                </div>
            </div>
            <!-- 第14行  -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span style="color:#fff">*</span>对接系统：</div>
                    <div class="label w300 textl">{{  getName(form.linkSystemList,'对接系统') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>客户定级：</div>
                    <div class="label w300 textl">{{  getName(form.customerGrade,'客户定级') }}</div>
                </div>
            </div>
            <!-- 第15行  -->
            <div class="cols">
                <div class="col-itms">
                    <!-- 新增字段 -->
                    <div class="title"><span style="color:#fff">*</span>流通类型：</div>
                    <div class="label w300 textl">{{  getName(form.circulateType,'流通类型') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>年销售额（元）：</div>
                    <div class="label w300 textl">{{ form.salesScaleAmount| numDigit}}</div>
                </div>
            </div>
            <!-- 第16行 -->
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>客户来源：</div>
                    <div class="label w300 textl">{{  getName(form.customerSource,'客户来源') }}</div>
                </div>
            </div>

          

            <!-- <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>企业地址：</div>
                     <div class="label w300 textl">{{ form.address ||'-'}}</div>
                </div>
            
                <div class="col-itms second">
                    <div class="title"><span>*</span>配送能力：</div>
                    <div class="label w300 textl">{{ form.hasDistributeCapacity=='Y'?'是':'否' }}</div>

                </div>
            </div>

            <div class="cols">
             
                <div class="col-itms ">
                    <div class="title"><span>*</span>公司组织形式：</div>
                    <div class="label w300 textl">{{ getName(form.companyType,'企业性质字典') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>有三方仓储：</div>
                    <div class="label w300 textl">{{ form.hasThirdPartyStorage=='Y'?'是':'否' }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>主营业务类型：</div>
                    <div class="label w300 textl">{{  getName(form.businessTypeList,'主营业务类型') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>主要下游客户：</div>
                    <div class="label w300 textl">{{ getName(form.downstreamCustomerList,'平台企业类型') }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>销售规模(元)：</div>
                     <div class="label w300 textl">{{ form.salesScaleAmount| numDigit}}</div>
                </div>
                <div class="col-itms second">
                     <div class="title"><span>*</span>业务联系人：</div>
                     <div class="label w300 textl">{{ form.contacts}}</div>
                </div>
          
            </div>

            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>联系电话：</div>
                    <div class="label w300 textl">{{ form.contactsMobile||'-'}}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>项目类型：</div>
                    <div class="label w300 textl">{{ getName(form.projectType,'合同内容分类') }}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>公司成立时间：</div>
                    <div class="label w300 textl">{{ form.registerDate||'-'}}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>公司法人：</div>
                    <div class="label w300 textl">{{ form.juridicalPerson||'-' }}</div>
                </div>
            </div> -->
        </div>
        <div class="import-title second">联系方式</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>所在省市区：</div>
                    <div class="label w300 textl">{{ form.venue||'-' }}</div>
                </div>
                <div class="col-itms  second">
                    <div class="title"><span>*</span>详细地址：</div>
                    <div class="label w300 textl">{{ form.address||'-'}}</div>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>业务联系人：</div>
                    <div class="label w300 textl">{{ form.contacts||'-' }}</div>
                </div>
                <div class="col-itms  second">
                    <div class="title"><span>*</span>联系电话：</div>
                    <div class="label w300 textl">{{ form.contactsMobile || '-' }}</div>
                </div>
            </div>
            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>公司电话：</div>
                    <div class="label w300 textl">{{ form.tenantTel||'-' }}</div>
                </div>
            </div>

        </div>
        
        <div class="import-title second">合作信息</div>
        <div class="customer-information">
            <div class="cols">
                <div class="col-itms">
                    <div class="title"><span>*</span>项目类型：</div>
                    <div class="label w300 textl">{{ getName(form.projectType,'合同内容分类') }}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>合作点数(%)：</div>
                    <div class="label w300 textl">{{ form.cooperateFeeRate||'-'}}</div>
                </div>
            </div>

            <div class="cols">
                <div class="col-itms ">
                    <div class="title"><span>*</span>商务费用(%)：</div>
                    <div class="label w300 textl">{{ form.businessFeeRate||'-'}}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>商务费用(元)：</div>
                    <div class="label w300 textl">{{ form.businessFee| numDigit}}</div>
                </div>
              
            </div>

            <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>合作规模(元)：</div>
                     <div class="label w300 textl">{{ form.cooperateScaleAmount| numDigit}}</div>
                </div>
                <div class="col-itms second">
                     <div class="title"><span>*</span>项目关系人：</div>
                     <div class="label w300 textl">{{ form.projectRelationPerson||'-'}}</div>
                </div>
          
            </div>

            <div class="cols">
                <div class="col-itms">
                     <div class="title"><span>*</span>运营项目经理：</div>
                     <div class="label w300 textl">{{ form.projectManagerName||'-'}}</div>
                </div>
                <div class="col-itms second">
                    <div class="title"><span>*</span>公司合伙人：</div>
                    <div class="label w300 textl">{{ form.cooperatePerson||'-'}}</div>
                </div>
            </div>
        </div>
        <div class="flow">
            <iframe scrolling="no" v-show="iframeSh" :src="iframeSrc" class="iframe-sty"></iframe>
        </div>
        <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" maxlength="100" placeholder="输入驳回理由（必填）" v-model="approveSuggest"> </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
            </span>
        </el-dialog>
        <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
            <el-input type="textarea" :rows="5" maxlength="100"  placeholder="请填写通过备注（选填）" v-model="approveSuggest"> </el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
            </span>
        </el-dialog>
        <div class="submit-btn-box submit_btn_wrap">
            <el-button type="borderBlack" size="small" @click="$router.go(-1)">取消</el-button>
            <el-button type="borderGreen"  size="small" v-if="form.staffGuid == staffGuid&&form.approveState == 'A'" style="margin-left:10px" @click="toRevoke">撤销</el-button>
            <el-button type="borderRed"   v-if="form.approveStaffGuids&&form.approveStaffGuids.indexOf(staffGuid)>-1&&form.approveState == 'A'" @click="rejectDialogVisible=true;approveSuggest=''">驳回</el-button>
            <el-button type="importNew" v-if="form.approveStaffGuids&&form.approveStaffGuids.indexOf(staffGuid)>-1&&form.approveState == 'A'" @click="passDialogVisible=true;approveSuggest=''">通过</el-button>
        </div>
    </div>
</template>
<script>
    import {bpmnroute } from '@/api/apiRoute';
    export default { 
        components:{
        },
        data() {
            return {
                fullscreenLoading: false,
                platformEnterpriseTypeList: [],//平台企业类型列表
                companyTypeList: [],//公司组织类型列表
                downstreamCustomerListList: [],//下游客户列表
                projectTypeList: [],//项目类型
                staffList:[],
                businessTypeListList: [//主营业务类型列表
                    {
                        label: '自营',
                        value: '自营'
                    },
                    {
                        label: '纯销',
                        value: '纯销'
                    },
                    {
                        label: '调拨',
                        value: '调拨'
                    },
                    {
                        label: '快批',
                        value: '快批'
                    },
                    {
                        label: '代理商',
                        value: '代理商'
                    },
                ],
                customerSourceList: [
                    {
                        label: '业务人员',
                        value: '业务人员'
                    },
                    {
                        label: '公司合伙人',
                        value: '公司合伙人'
                    },
                    {
                        label: '公司网站/公众号',
                        value: '公司网站/公众号'
                    },
                    {
                        label: '内部员工',
                        value: '内部员工'
                    },
                    {
                        label: '高管',
                        value: '高管'
                    },
                    {
                        label: '政府',
                        value: '政府'
                    }

                ],
                customerGradeList: [
                    {
                        label: '重要客户',
                        value: '重要客户'
                    },
                    {
                        label: '战略客户',
                        value: '战略客户'
                    },
                    {
                        label: '一般客户',
                        value: '一般客户'
                    },
                ],//客户定级列表
                form: {
                    platformEnterpriseType: '',//公司类型
                    companyType: '',//公司组织形式
                    createProjectStaffGuid: '',//立项人
                    createProjectDate: '',//立项时间
                    hasThirdPartyStorage: 'N',//是否有三方仓储
                    hasDistributeCapacity: 'N',//是否有配送能力
                    tenantName: '',//客户名称
                    address: '',//客户地址
                    isIpo: 'N',//是否上市
                    businessTypeList: '',//主营业务类型
                    registerCapitalAmount: '',//注册资本
                    businessFee: '',//商务费用
                    businessFeeRate: '',//商务费率
                    cooperateFeeRate: '',//合作费率
                    cooperatePerson: '',//合伙人
                    projectRelationPerson: '',//项目关系人
                    customerSource: '',//客户来源
                    customerGrade: '',//客户定级
                    contactsMobile: '',//联系电话
                    contacts: '',//联系人
                    salesScaleAmount: '',//销售规模
                    cooperateScaleAmount: ''//合作规模
                },
                createProjectFileList:[],
                gradeSurveyFileList:[],
                //流程相关
                iframeSh:false,
                iframeSrc:'',
                rejectDialogVisible:false,
                passDialogVisible:false,
                staffGuid:'',
                approveSuggest:'',
            }
        },
        watch: {
            
        },
        created() {
          
            if (this.$route.query.form) {
                let form = JSON.parse(decodeURIComponent(this.$route.query.form));
                let token = localStorage.token;
                //流程展示
                this.iframeSh = true;
                this.iframeSrc = bpmnroute + '/iframeBpmn?processInstanceId=' + form.camundaInstanceId + '&camundaDeploymentId=' + form.camundaDeploymentId + '&token=' + token;
                //文件
                if (form.createProjectFileList) {
                    form.createProjectFileList.forEach(item => {
                        this.createProjectFileList = [{
                            name: item.fileName,
                            path: item.path
                        }]
                    })
                }
                if (form.gradeSurveyFileList) {
                    form.gradeSurveyFileList.forEach(item => {
                        this.gradeSurveyFileList = [{
                            name: item.fileName,
                            path: item.path
                        }]
                    })
                }
                this.form = form;
                this.guid = form.guid;
            }
            let userinfo = JSON.parse(localStorage.userInfo);
            this.staffGuid = userinfo.staffGuid;
            this.getStaffList();
        },
        methods: {
            getName(name, key) {
                if(!name) return '-';
                let list = this.getCodeListByKey(key);
                if(typeof name == 'object'){
                    let newArr = [];
                    name.forEach(item=>{
                        list.forEach(el=>{
                            if(el.value==item){
                                newArr.push(el.text);
                            }
                        })
                    })
                    return newArr.length?newArr.join('、'):'-';

                }else{
                    let lisArr = list.filter(item => item.value == name);
                    return lisArr.length ? lisArr[0].text : '-';
                }
            
            },
            //驳回提交
            toRejectSubmit() {
                if (this.approveSuggest == '') {
                    this.$message.error('请填写驳回理由！');
                    return;
                }
                let query = {
                    guid: this.form.approveGuid,
                    flowType: '00009',
                    approveSuggest: this.approveSuggest,
                    approveStaffGuid: this.staffGuid
                };
                this.fullscreenLoading = true;
      
                this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.rejectDialogVisible = false;
                        this.$message.success('驳回成功！');
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
            },
            //通过
            toPassSubmit() {
                let query = {
                    guid: this.form.approveGuid,
                    flowType: '00009',
                    approveSuggest: this.approveSuggest,
                    approveStaffGuid: this.staffGuid
                };
                this.fullscreenLoading = true;
                this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
                    this.fullscreenLoading = false;
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        this.passDialogVisible = false;
                        this.$message.success('审批通过！');
                        this.$router.go(-1);
                    } else {
                        this.$message.error(res.data.msg);
                    }
                });
               
            },
            //撤回
            toRevoke() {
                let self = this;
                this.$confirm('确定撤销吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                        let query = {
                            guid: this.form.approveGuid,
                            flowType: '00009',
                            approveStaffGuid: this.staffGuid
                        };
                        self.fullscreenLoading = true;
                        self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
                            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                                self.fullscreenLoading = false;
                                self.$message.success('撤销成功！');
                                self.$router.go(-1);
                            } else {
                                self.$message.error(res.data.msg);
                            }
                        });
                    })
                    .catch(() => {
                        self.$message({
                            type: 'info',
                            message: '已取消操作！',
                         });
                    });
            },
            getStaffList() {
                let req = {
                    tenantGuid:localStorage.guid,
                    staffType:1,
                }
                this.api.postJson(`/${serverConfig.msPersonnelService}/staff/get-select-staff`,req).then((res) => {
                    if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                        console.log(res.data.data)
                        this.staffList = res.data.data;
                    } else {
                        this.$message.error(res.data.data.msg);
                    }
                });
            },
            //获取流程列表
            seeDetail(url) {
                window.open('https://view.officeapps.live.com/op/view.aspx?src='+encodeURIComponent(url));
            },
        }
    };
</script> 